import { DashboardContext } from "./_context";

export const DashboardProvider = DashboardContext.Provider